/*
 * Card carousel for sections/eb-sub-reviews.
 *
 * The track is a scroll-snap row (layout lives in eb-subscriptions.css), so
 * swiping and trackpads work natively. This adds the testimonial-style
 * controls: round arrows either side of pill dots. How many cards fit per
 * view changes with the breakpoint, so the dots are rebuilt on resize - one
 * dot per stop the track can actually scroll to.
 */

if (!customElements.get('eb-carousel')) {
  customElements.define(
    'eb-carousel',
    class EbCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.eb-sub-carousel__track');
        this.slides = Array.from(this.querySelectorAll('.eb-sub-carousel__slide'));
        this.dotsWrap = this.querySelector('.eb-carousel-nav__dots');
        if (!this.track || !this.dotsWrap) return;

        this.querySelectorAll('.eb-carousel-nav__arrow').forEach((arrow) => {
          arrow.addEventListener('click', () => this.go(this.current() + Number(arrow.dataset.dir)));
        });

        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.mark());
        }, { passive: true });

        this.resizeObserver = new ResizeObserver(() => this.build());
        this.resizeObserver.observe(this.track);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      step() {
        return this.slides.length > 1 ? this.slides[1].offsetLeft - this.slides[0].offsetLeft : this.track.clientWidth;
      }

      pages() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        return max > 1 ? Math.round(max / this.step()) + 1 : 1;
      }

      current() {
        return Math.round(this.track.scrollLeft / this.step());
      }

      build() {
        const count = this.pages();
        this.querySelector('.eb-carousel-nav').hidden = count < 2;
        if (this.dotsWrap.children.length !== count) {
          this.dotsWrap.innerHTML = '';
          for (let i = 0; i < count; i++) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'eb-carousel-nav__dot';
            dot.setAttribute('aria-label', `Show reviews, stop ${i + 1} of ${count}`);
            dot.addEventListener('click', () => this.go(i));
            this.dotsWrap.appendChild(dot);
          }
        }
        this.mark();
      }

      mark() {
        const active = Math.min(this.current(), this.dotsWrap.children.length - 1);
        Array.from(this.dotsWrap.children).forEach((dot, i) => {
          if (i === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      // Past either end it wraps round, as the testimonial slider does.
      go(target) {
        const count = this.pages();
        const page = (target + count) % count;
        this.track.scrollTo({ left: page * this.step() });
      }
    }
  );
}
